var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.963,
    height: 50,
    viewBox: "0 0 39.963 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a5a9c7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.827,50H7.136C3.2,50,0,46.5,0,42.188V26.172c0-4.308,3.2-7.813,7.136-7.813H9.273V11.471C9.273,5.146,14.075,0,19.978,0s10.7,5.146,10.7,11.471v6.888h2.144c3.935,0,7.136,3.5,7.136,7.813V33.4a1.791,1.791,0,1,1-3.568,0V26.172a3.753,3.753,0,0,0-3.568-3.907H7.136a3.753,3.753,0,0,0-3.568,3.907V42.188a3.753,3.753,0,0,0,3.568,3.906H32.827a3.753,3.753,0,0,0,3.568-3.906,1.791,1.791,0,1,1,3.568,0C39.962,46.5,36.761,50,32.827,50ZM19.978,3.906a7.368,7.368,0,0,0-7.136,7.565v6.888H27.114V11.471A7.369,7.369,0,0,0,19.978,3.906ZM30.106,35.8a2.05,2.05,0,1,1,1.865-2.042A1.962,1.962,0,0,1,30.106,35.8Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 1.865,
    cy: 2.042,
    rx: 1.865,
    ry: 2.042,
    transform: "translate(14.834 31.713)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 1.865,
    cy: 2.042,
    rx: 1.865,
    ry: 2.042,
    transform: "translate(8.166 31.713)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 1.865,
    cy: 2.042,
    rx: 1.865,
    ry: 2.042,
    transform: "translate(21.491 31.713)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.7426077e.svg";
export { ForwardRef as ReactComponent };